<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtLayout, NuxtPage} from '#components';
    import {useAsyncData, useHead, useHostSettings, useHTMLAttrsLang, useScripts, useSeoMeta} from '#imports';

    useHTMLAttrsLang();

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }
    useSeoMeta({robots: 'noindex'});
</script>
